module.exports = __webpack_public_path__ + "img/icon-warning-stroke.57d5bf6a.png";